/**
 * TanStack Query hooks for `hourly-data-widget-clicks-conversions-cr-epc-cost`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	hourlyDataWidgetClicksConversionsCrEpcCostQueryKeys,
	type CreateHourlyDataWidgetClicksConversionsCrEpcCostBody,
	type ListHourlyDataWidgetClicksConversionsCrEpcCostResponse,
	type HourlyDataWidgetClicksConversionsCrEpcCostRow,
} from "./api";

export function useHourlyDataWidgetClicksConversionsCrEpcCostList(): UseQueryResult<ListHourlyDataWidgetClicksConversionsCrEpcCostResponse, Error> {
	return useQuery({
		queryKey: hourlyDataWidgetClicksConversionsCrEpcCostQueryKeys.list(),
		queryFn: list,
	});
}

export function useHourlyDataWidgetClicksConversionsCrEpcCostCreate(): UseMutationResult<HourlyDataWidgetClicksConversionsCrEpcCostRow, Error, CreateHourlyDataWidgetClicksConversionsCrEpcCostBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: hourlyDataWidgetClicksConversionsCrEpcCostQueryKeys.all });
		},
	});
}

export function useHourlyDataWidgetClicksConversionsCrEpcCostDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: hourlyDataWidgetClicksConversionsCrEpcCostQueryKeys.all });
		},
	});
}
